import useTrans from "@/hooks/useTrans"
import { Container, Stack, Typography } from "@mui/material"
import { Advertisement } from "@/components/dashboard/advertisement"

const RenecLendInsights = () => {
  const trans = useTrans()

  return (
    <Container maxWidth='xl' className='py-10 sm:py-20'>
      <Stack alignItems='start' gap={1}>
        <Typography className='text-neutral-1000 text-left font-montserrat text-2xl sm:text-[2.5rem] font-bold leading-tight'>
          {trans.home.renec_lend_insights}
        </Typography>
        <Typography className='text-sm sm:text-base text-neutral-600 text-left sm:max-w-2xl'>
          {trans.home.stay_informed_with_the_latest_news}
        </Typography>
      </Stack>

      <Advertisement />
    </Container>
  )
}

export default RenecLendInsights
